module.exports = __webpack_public_path__ + "static/media/telegram.4017b4c6.svg";